/**
 * Colors used within react and react-native components
 */
var Colors;
(function (Colors) {
    Colors["dark"] = "#161616";
    Colors["light"] = "#ffffff";
    Colors["bermuda"] = "#80D1CA";
    Colors["viola"] = "#C087AB";
    Colors["buttermilk"] = "#F7E0A6";
    Colors["polo"] = "#8AAED0";
    Colors["mint"] = "#ADE9DA";
    Colors["transparent"] = "none";
})(Colors || (Colors = {}));

export { Colors };
//# sourceMappingURL=colors.esm.js.map
